export default function PHP_libxml_get_last_error() {
  return (
    <div>
      <h1>PHP_libxml_get_last_error</h1>
    </div>
  );
}
